import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  bannerContainer: {
    display: 'flex',
    minHeight: '300px',
    backgroundColor: theme.palette.grey[300],
    alignItems: 'center',
    padding: theme.spacing(13, 5),
    position: 'relative',
    zIndex: theme.zIndex.xRayText,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(10, 1),
    },
  },
  bannerTextWrapper: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 11),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 12),
    },
  },
  bannerText: {
    margin: theme.spacing(7, 0, 0),
  },
}))
